import React from "react";
import styled from "styled-components";

import { VoteStatus } from "types/voteEnum";

import BasicProposalButton from "components/vote/Quizzbox/common/Buttons/BasicProposalButton";

type Props = {
    options: Array<{ id: string; text: string }>;
    answers: Array<string | undefined>;
    index: number;
    setVoteStatus: React.Dispatch<React.SetStateAction<VoteStatus>>;
    setAnswers: React.Dispatch<React.SetStateAction<Array<string | undefined>>>;
    disabledOptions: string[];
    closeAccordion?: () => void;
};

const OptionsWrapper = ({
    options,
    answers,
    index,
    setAnswers,
    setVoteStatus,
    disabledOptions,
    closeAccordion,
}: Props) => {
    const renderOptions = () => {
        return options.map((option) => {
            const isActive = answers[index - 1] === option.id;
            const isDisabled = disabledOptions.includes(option.id);

            const onClickProposal = () => {
                if (isDisabled) {
                    return;
                }

                const newAnswers = [...answers];
                if (isActive) {
                    newAnswers[index - 1] = undefined;
                    setAnswers(newAnswers);
                    setVoteStatus(VoteStatus.Idle);
                    return;
                }

                newAnswers[index - 1] = option.id;
                setAnswers(newAnswers);
                if (closeAccordion) {
                    closeAccordion();
                }
            };

            return (
                <BasicProposalButton
                    key={option.id}
                    text={option.text}
                    isActive={isActive}
                    onClick={onClickProposal}
                    isDisabled={isDisabled}
                />
            );
        });
    };

    return <Wrapper>{renderOptions()}</Wrapper>;
};

const Wrapper = styled.div`
    margin-top: 15px;
`;

export default OptionsWrapper;
